import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Utils from '../../../services/UtilsService';
import AuthorizationContext from '../../../contexts/AuthorizationContext';
import { EMPLOYER_ICON } from '../../../constants/IconType';
import Icon from '../../common/IconComponent';
import DropdownMenu from '../../common/dropdown-menu/DropdownMenu';
import EmployerContext from '../../../contexts/EmployerContext';
import RecruiterContext from '../../../contexts/RecruiterContext';
import SettingsContext from '../../../contexts/SettingsContext';
import { getEntityInfo, useUserMenuItems } from './UserMenuUtils';
import useStyle from './UserMenuStyle';
import Tooltip from '../../material-ui-kit/Tooltip/Tooltip';

// Modified by AI on 05/14/2026. Edit #5.
const UserMenu = ({ className = '', history = {}, isMenuHidden = false }) => {
    const classes = useStyle();
    const rootClasses = Utils.getClassName([
        classes.root,
        className,
    ]);

    const { t } = useTranslation();

    const {
        user,
    } = useContext(AuthorizationContext);
    const { employer } = useContext(EmployerContext);
    const { recruiter } = useContext(RecruiterContext);
    const {
        environmentSettings,
    } = useContext(SettingsContext);

    const settings = {
        ...environmentSettings,
    };

    const entity = getEntityInfo({ user, employer, recruiter });
    const menuItems = useUserMenuItems({
        user,
        employer,
        recruiter,
        settings,
        history,
    });

    return (
        <div className={rootClasses}>
            { entity && <div className={classes.entityInfo}>
                <Icon
                    className={classes.entityIcon}
                    url={entity.logoUrl}
                    type={EMPLOYER_ICON}
                />
                <div className={classes.entityDetails}>
                    <span className={classes.entityLabel}>{t(entity.label)}</span><br/>
                    <Tooltip
                        enterDelay={500}
                        title={<div style={{ whiteSpace: 'pre-line' }}>{entity.name}</div>}
                        placement={'bottom-start'}
                    >
                        <span className={classes.entityName}>{entity.name}</span>
                    </Tooltip>
                </div>
            </div> }
            <DropdownMenu
                imageUrl={user.picture}
                menuItems={menuItems}
                isMenuHidden={isMenuHidden}
            />
        </div>
    );
};

UserMenu.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object,
    isMenuHidden: PropTypes.bool,
};

export default withRouter(UserMenu);
